import React, { Component } from 'react';
import BlogWrapper from './BlogWrapper';


export default class BlogLast extends Component {

    constructor() {
        super();
        this.state = { posts: [] };
    }

    componentWillMount() {

        const requestInfo = {
            method: 'GET',
            headers: new Headers({
                'Content-type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            })
        };

        fetch('http://api.fcsistema.com.br/api-website-fc/post/last', requestInfo)
            .then(response => response.json())
            .then(data => {
                console.log(data);
                this.setState({ posts: data });
            })
            .catch(error => {
                this.setState({ msg: error.message });
            });
    }

    render() {
        return (
            <div>
                <section className="ptb-50 grid-news-hover">
                    <div className="container">

                        <div className="text-center mb-80">
                            <h2 className="section-title">Ultimas notícias</h2>
                        </div>

                        <div className="row">
                            {
                                this.state.posts.map(post => {
                                    return (
                                        <BlogWrapper id={post.id} width={4} key={post.id} titulo={post.titulo} 
                                            resumo={post.resumo} categoria={post.categoria.nome}
                                            dataPublicacao={post.dataPublicacao} imgLink={post.imagemLink} />
                                    );
                                })
                            }
                        </div>

                    </div>
                </section>


            </div>);
    }

}


// WEBPACK FOOTER //
// ./src/components/BlogLast.js